import { isValid as dateIsValid, parse } from 'date-fns';
import type { TestFunction } from 'yup';

import type { TCreditFormCommonFields } from 'entities/creditForm';

export const isDateLaterThanOtherDateField =
  (field: keyof TCreditFormCommonFields, message?: string, formatString = 'dd.MM.yyyy'): TestFunction =>
  (value, context) => {
    const fieldValue = context.parent[field] as unknown;
    const date = parse(typeof fieldValue === 'string' ? fieldValue : '', formatString, new Date());
    const asDate = parse(typeof value === 'string' ? value : '', formatString, new Date());
    const isValid = !value || (dateIsValid(date) && date <= asDate);
    return isValid || context.createError({ path: context.path, message: message || 'Некорректная дата' });
  };
